<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>Cadastrar Dependente</h2>
          </div>
        </div>
      </div>

      <div>
        <form [formGroup]="formularioDeDependente" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>

          <div class="form-row">
            <div class="form-group col-md-8">
              <label for="nome">Nome do Dependente</label>
              <input type="text" class="form-control" id="nome" required trim="blur" name="nome" formControlName="nome"
                upperCase [readonly]="!paciente">
              <div
                *ngIf="formularioDeDependente.controls.nome.invalid && (formularioDeDependente.controls.nome.dirty || formularioDeDependente.controls.nome.touched)"
                class="alert alert-danger">
                <div *ngIf="formularioDeDependente.controls.nome.errors?.required">
                  O campo Nome do Dependente é obrigatório.
                </div>
                <div *ngIf="formularioDeDependente.controls.nome.errors?.minlength">
                  O campo Nome do Dependente precisa conter mais do que 5 caracteres.
                </div>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="dataNascimento">Data Nasc.</label>
              <input type="date" class="form-control" id="dataNascimento" formControlName="dataNascimento"
                [readonly]="!paciente">
              <div
                *ngIf="formularioDeDependente.controls.dataNascimento.invalid && (formularioDeDependente.controls.dataNascimento.dirty || formularioDeDependente.controls.dataNascimento.touched)"
                class="alert alert-danger">
                <div *ngIf="formularioDeDependente.controls.dataNascimento.errors?.required">
                  O campo Data de Nascimento é obrigatório.
                </div>
                <div *ngIf="formularioDeDependente.controls.dataNascimento.errors!.dataValidada">
                  O campo Data de Nascimento está inválido.
                </div>
              </div>
            </div>

          </div>

          <div class="menu-formulario">
            <div class="menu-formulario-botoes margin-right-10">
              <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                [disabled]="!formularioDeDependente.valid || !paciente">
                <mat-icon>save</mat-icon>
              </button>
            </div>
            <div class="menu-formulario-botoes">
              <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()" matTooltip="Voltar">
                <mat-icon>west</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>